const PATHNAME_404 = '/404/';

export default PATHNAME_404;
